import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Composant pour les métadonnées dynamiques (favicon, title, etc.)
import SiteHead from './components/common/SiteHead';

// Pages publiques
import Home from './pages/Home/Home';
import Projects from './pages/Projects/Projects';
import ProjectDetail from './pages/Projects/ProjectDetail';
import Blog from './pages/Blog/Blog';
import Article from './pages/Blog/Article';
import About from './pages/About/About';
import NotFound from './pages/NotFound';

// Pages Admin
import AdminPortal from './pages/Admin/AdminPortal';
import AdminLogin from './pages/Admin/AdminLogin';
import AdminDashboard from './pages/Admin/AdminDashboard';
import ProtectedRoute from './components/admin/ProtectedRoute';

// Admin Managers
import HomeManager from './pages/Admin/managers/HomeManager';
import ProjectManager from './pages/Admin/managers/ProjectManager';
import BlogManager from './pages/Admin/managers/BlogManager';
import AboutManager from './pages/Admin/managers/AboutManager';
import MediaManager from './pages/Admin/managers/MediaManager';
import SettingsManager from './pages/Admin/managers/SettingsManager';
import MessagesManager from './pages/Admin/managers/MessagesManager';

import './App.css';

function App() {
  return (
    <>
      {/* Gestion dynamique des métadonnées (favicon, title, description) */}
      <SiteHead />
      
      <div className="App">
        <Routes>
          {/* Routes Publiques */}
          <Route path="/" element={<Home />} />
          <Route path="/projets" element={<Projects />} />
          <Route path="/projets/:slug" element={<ProjectDetail />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<Article />} />
          <Route path="/a-propos" element={<About />} />

          {/* Route Admin - Portail sécurisé */}
          <Route path="/Jesuiskgustave" element={<AdminPortal />} />
          
          {/* Route Admin - Login Firebase */}
          <Route path="/admin-login" element={<AdminLogin />} />

          {/* Routes Admin Protégées */}
          <Route path="/admin" element={<ProtectedRoute />}>
            <Route index element={<AdminDashboard />} />
            <Route path="accueil" element={<HomeManager />} />
            <Route path="projets" element={<ProjectManager />} />
            <Route path="blog" element={<BlogManager />} />
            <Route path="a-propos" element={<AboutManager />} />
            <Route path="medias" element={<MediaManager />} />
            <Route path="parametres" element={<SettingsManager />} />
            <Route path="messages" element={<MessagesManager />} />
          </Route>

          {/* Page 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </>
  );
}

export default App;